import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../service/auth.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import $ from 'jquery';
import {DomSanitizer} from '@angular/platform-browser';
import {user_accessInterface, SharedService} from '../service/shared.service';
import Player from '@vimeo/player';

@Component({
    selector: 'app-grow-onethird',
    templateUrl: './grow-onethird.component.html',
    styleUrls: ['./grow-onethird.component.css']
})
export class GrowOnethirdComponent implements OnInit {
    @Input() id: any;
    @Input() main_color_value: any;
    @Input() user_access: user_accessInterface;
    @Input() heading_font_color: any;
    @Input() title_color: any;
    @Input() is_service_note: any


    @Output() result = new EventEmitter<any>()
    @Output() upload = new EventEmitter<any>()
    @Output() notes = new EventEmitter<any>()
    @Output() completechapter = new EventEmitter<any>()
    @Output() assignment = new EventEmitter<any>()
    @Output() notesicon = new EventEmitter<any>()
    @Output() page_id = new EventEmitter<any>()


    api = environment.apiEndpoint;
    imgurl = environment.imageurl;
    tokenvalue: string;
    fullpagedata: any;
    pagedata: any;
    full_title: any;
    full_description: any;
    brandname: any;
    color: any;
    main_color: any;
    whiteornot: any;
    sc_introduction: any;
    mc_introduction: any;
    sc_onthird_image: any;
    backgorund_image: any;
    showassignment: boolean = false;
    allow_upload: any;
    assign_type: any;
    learninggoals: any[] = [];
    assignmentdata: any;
    teamdata: any[] = [];
    teamsvalue: any[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];
    pageheader_image: any;
    assignmentid: any;
    user_slug: any;
    teamid: any;
    assignment_name: any;
    notification: any = '0';
    main_font: string;
    second_font: string;
    bullet_back_src: string;
    bullet_position_top = 8;
    link_back_src: string;
    check_bac_src: string;
    alltutordata: any;
    video_src: any;
    abstract_segment1: any;
    abstract_segment2: any;
    abstract_segment3: any;
    title_segment1: any;
    title_segment2: any;
    title_segment3: any;
    player: any;
    iframe: HTMLIFrameElement;
    start_segment2: any;
    start_segment3: any;
    title1_img: any;
    title2_img: any;
    title3_img: any;
    deep_dive_segment1: any;
    deep_dive_segment2: any;
    deep_dive_segment3: any;
    tutorimg: string;
    tutorimg_active: string;
    backcolor: any;
    vimeo_video_value: any;
    mainHolder: any
    service_enforce: any = 0;
    complete_chapter: any;
    li_font_color: string;
    fk_brand_id: string;
    changeicon: boolean;
    icon_value: string;


    constructor(public authservice: AuthService, private ar: ActivatedRoute, private httpclient: HttpClient, private domSanitizer: DomSanitizer, private shareservice: SharedService) {
        Window["myComponent"] = this;      //for innerhtml click event
    }

    ngOnInit() {
        this.fk_brand_id = localStorage.getItem("fk_brand_id")


        if (this.id) {
            this.getonethirddata(this.id);
            this.main_color = this.main_color_value
            this.user_slug = localStorage.getItem('user_slug')
            this.getTuotrVideo()


        }

    }


    getonethirddata(id) {


        this.tokenvalue = localStorage.getItem('auth-token');
        this.httpclient.get(this.api + "auth/pagesingledata?id=" + id + "&token=" + this.tokenvalue).subscribe((data: onethirdpagedata) => {

            this.fullpagedata = data.differentpage;
            this.pagedata = data.page;
            this.notification = data.notification
            this.pageheader_image = this.pagedata.header_thumbnail
            this.full_title = this.pagedata['page_title'];
            this.full_description = this.pagedata.page_description;
            this.color = this.pagedata.chaptercolor;
            this.brandname = this.pagedata.brandname;
            this.backgorund_image = this.fullpagedata.background_image
            this.assignmentid = this.fullpagedata.assignment_id;
            this.page_id.emit({pid: this.pagedata.id});
            if (localStorage.getItem('service_enforce') == '1') {
                this.complete_chapter = this.pagedata.complete_chapter
                this.service_enforce = localStorage.getItem('service_enforce')
                this.completechapter.emit(this.complete_chapter)

            }

            if (this.fullpagedata.sc_background_is == "1") {
                this.whiteornot = this.heading_font_color;
                this.backcolor = "#ffffff";
                this.li_font_color = "#333333";
            }
            if (this.fullpagedata.sc_background_is == "0") {
                this.whiteornot = this.title_color ? this.title_color : "#ffffff";
                this.backcolor = this.main_color;
                this.li_font_color = "#ffffff";
            }
            //ol li::before margin-left :-1em changed to 0 em  and padding 0px

            ////check brand

            if (this.brandname == 'park') {
                this.main_font = "SilkaMono";
                this.second_font = "'Roboto', sans-serif";
                this.bullet_position_top = 7;
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-blue.svg"
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-green.svg"
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'yellow') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-yellow.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-yellow.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-yellow.svg"
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-yellow.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-yellow.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-red.svg"
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'gray') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-gray.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-gray.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-gray.svg"
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-gray.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Park/tutor-play-park-academy-gray.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
            }

            if (this.brandname == 'grow') {
                this.main_font = "'Museo W01 500', HelveticaNeue, Helvetica";
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'warm red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-warm-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-warm-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-warm-red.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-warm-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-warm-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }

                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-purple.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-purple.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-purple.svg";
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-orange.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-orange.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-orange.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-red.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-green.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'aqua') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-aqua.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-aqua.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-aqua.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Grow/tutor-play-grow-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
            }

            if (this.brandname == 'draeger') {
                this.main_font = "'CotySans-Bold'";
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/draeger/bullet-draeger-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/draeger/external-draeger-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/draeger/check-draeger-red.svg"
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/draeger/bullet-draeger-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/draeger/external-draeger-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/draeger/check-draeger-green.svg"
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'light-blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/draeger/bullet-draeger-light-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/draeger/external-draeger-light-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/draeger/check-draeger-light-blue.svg"
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-light-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-light-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/draeger/bullet-draeger-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/draeger/external-draeger-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/draeger/check-draeger-blue.svg"
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/draeger/tutor-play-draeger-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/draeger/bullet-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/draeger/external-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/draeger/check-orange.svg"
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/draeger/tutor-play-orange.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/draeger/tutor-play-orange.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }


            }
            if (this.brandname == 'coty') {
                this.main_font = "'CotySans-Bold'";
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-purple.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-purple.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-purple.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'yellow') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-yellow.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-yellow.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-yellow.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-yellow.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-yellow.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-orange.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-orange.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-orange.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'magenta') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-magenta.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-magenta.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-magenta.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-magenta.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-magenta.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-red.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-red.svg"
                    }

                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'light purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-lightpurple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-lightpurple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-lightpurple.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-lightpurple.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-lightpurple.svg"
                    }

                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'dark blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-darkblue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-darkblue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-darkblue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-darkblue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-darkblue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'aqua') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-aqua.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-aqua.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-aqua.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-aqua.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-aqua.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-green.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Coty/tutor-play-coty-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
            }
            if (this.brandname == 'lego') {
                this.main_font = "CeraPro, Arial, Helvetica, sans-serif"
                this.second_font = "CeraPro, 'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                this.bullet_position_top = 3;
                if (this.color == 'medium lilac') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-lilac.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-lilac.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-lilac.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Lego/tutor-lego-lilac.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Lego/tutor-lego-lilac.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'bright blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-blue.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Lego/tutor-lego-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Lego/tutor-lego-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'dark green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-green.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-green.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Lego/tutor-lego-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Lego/tutor-lego-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'bright red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-red.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-red.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Lego/tutor-lego-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Lego/tutor-lego-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
            }
            if (this.brandname == "raymond") {
                this.main_font = "'Airstrip-Four', Arial, HelveticaNeue, Helvetica"
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Raymond/bullet-raymond-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Raymond/external-raymond-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Raymond/check-raymond-red.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Raymond/tutor-play-raymond-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Raymond/tutor-play-raymond-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }

            }
            if (this.brandname == "gsk") {
                this.main_font = "'Arial', HelveticaNeue, Helvetica, Geneva, sans-serif"
                this.second_font = "'Arial', HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-orange.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-orange.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-orange.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'light orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-lightorange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-lightorange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-lightorange.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-lightorange.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-lightorange.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'aqua') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-aqua.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-aqua.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-aqua.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-aqua.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-aqua.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-green.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-red.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-red.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-red.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-purple.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-purple.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-purple.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'brown') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-brown.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-brown.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-brown.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-brown.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-brown.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'beige') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-beige.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-beige.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-beige.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-beige.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-beige.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'light') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-light.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-light.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-light.svg";
                    if (this.fullpagedata.sc_background_is == "1") {

                        this.tutorimg = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-light.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Gsk/tutor-play-gsk-light.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
            }
            if (this.brandname == 'drager') {
                this.main_font = "'draeger'"
                this.second_font = "'draeger2'";
                console.log(this.color)
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-purple.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-purple.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-purple.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'magenta') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-magenta.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-magenta.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-magenta.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-magenta.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-magenta.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'spruce') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-spruce.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-spruce.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-spruce.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-spruce.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-spruce.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'ocean') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-ocean-new.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-ocean.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-ocean.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-ocean.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-ocean.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'rose') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-rose.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-rose.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-rose.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-rose.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-rose.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'lime') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-lime.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-lime.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-lime.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-lime.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-lime.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }
                if (this.color == 'coral') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-coral.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-coral.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-coral.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-coral.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Draeger/tutor-play-draeger-coral.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }

                }

            }

            if (this.brandname == 'electrolux') {
                this.main_font = "'electrolux-sans-semibold'"
                this.second_font = "'electrolux-regular'";
                console.log(this.color)
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'dark blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-dark-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-dark-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-dark-blue.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-dark-blue.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-dark-blue.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'gray') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-gray.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-gray.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-gray.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-gray.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-gray.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'brown') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-brown.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-brown.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-brown.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-brown.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-brown.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-green.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-green.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-green.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'wine') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-wine.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-wine.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-wine.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-wine.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-wine.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
                if (this.color == 'mustard') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-mustard.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-mustard.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-mustard.svg";
                    if (this.fullpagedata.sc_background_is == "1") {
                        this.tutorimg = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-mustard.svg";
                        this.tutorimg_active = "./assets/img/snippet/BrandElements/Electrolux/tutor-play-electrolux-mustard.svg"
                    }
                    if (this.fullpagedata.sc_background_is == "0") {
                        this.tutorimg = "./assets/img/snippet/tutor-play-white.svg";
                        this.tutorimg_active = "./assets/img/snippet/tutor-play-white.svg"
                    }
                }
            }


            // p{font-family:'+ this.main_font+'!important}

            this.sc_introduction = this.domSanitizer.bypassSecurityTrustHtml(this.fullpagedata.sc_introduction + '<style>#subcontent h1{color:' + this.whiteornot + '!important } #subcontent h2{color:' + this.whiteornot + '!important } #subcontent h3{color:' + this.whiteornot + '!important } #subcontent h4{color:' + this.whiteornot + '!important } #subcontent h5{color:' + this.whiteornot + '!important } #subcontent h6{color:' + this.whiteornot + '!important }  #subcontent,#Content h1,h2,h3,h4,h5,h6{font-family:' + this.main_font + '} #subcontent ul {list-style-type: none;} ol {list-style-type:none}  #subcontent ol  li::before {content: counter(li); color: ' + this.heading_font_color + '!important; display: inline-block; width: 1em; margin-left: 0em ;font-size:32px; } #subcontent ol li {counter-increment: li} #subcontent .emphasized{color:' + this.whiteornot + '!important } #subcontent ul,li,p,strong{font-family:' + this.second_font + '} #subcontent ul.list { width:auto; } #subcontent ul.list li { padding:0 0 0 25px; background:url("' + this.bullet_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat; list-style-type: none; } a.external { display: block;color:' + this.heading_font_color + '!important; line-height: 25px;float: left;background: url("' + this.link_back_src + '") 0 8px no-repeat;padding: 0 0 7px 21px !important; } ul.link-list li {width: 100%;overflow: hidden;}  ul.link-list li a { border-bottom: 0 !important;} ul.link-list li { width: 100%;overflow: hidden;} #subcontent ul.check-list { width:auto; } #subcontent ul.check-list li { padding:0 0 0 25px !important; background:url("' + this.check_bac_src + '") 0 3px no-repeat; list-style-type: none ; } #subcontent ul.small-ordered-list .ordered-number { color:' + this.heading_font_color + '} #subcontent ul.small-ordered-list .ordered-number { color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important}  #subcontent ul.ordered-list .ordered-number {color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important} .tutor-video-content a { background: url("' + this.tutorimg + '") 0 3px no-repeat; padding:0 0 20px 20px !important;}  .tutor-video-content a.active{ background: url("' + this.tutorimg_active + '") 0 -82px no-repeat} #subcontent p  {color:' + this.li_font_color + '}  #subcontent span  {color:' + this.li_font_color + '} #subcontent li  {color:' + this.li_font_color + '} #Content .richtext div.media-block .capture {background-color:' + this.main_color + '} #Content .richtext div.media-block .capture p {color:black !important;} #subcontent p {padding:0px 0px 18px} #subcontent span.highlighted {color:' + this.heading_font_color + '} #subcontent ul.small-ordered-list .ordered-text {width:300px !important} #subcontent ul.ordered-list .ordered-text1 {width:300px !important} #subcontent div.capture h3  {color:#ffffff !important} #subcontent a {color:' + this.whiteornot + '!important;}  .sub-bottom {border-bottom: 1px dotted ' + this.whiteornot + '!important;}</style>');
            this.mc_introduction = this.domSanitizer.bypassSecurityTrustHtml(this.fullpagedata.mc_introduction + '<style>#maincontent h1{color:' + this.heading_font_color + '!important} #maincontent h2{color:' + this.heading_font_color + '!important} #maincontent h3{color:' + this.heading_font_color + '!important} #maincontent h4{color:' + this.heading_font_color + '!important} #maincontent h5{color:' + this.heading_font_color + '!important} #maincontent h6{color:' + this.heading_font_color + '!important} #maincontent,#Content h1,h2,h3,h4,h5,h6{font-family:' + this.main_font + '} #assignment ul { width:auto; } #assignment ul li { padding:0 0 0 25px !important; background:url("' + this.bullet_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat; list-style-type: none; }   #maincontent ul {list-style-type:none}  ol {list-style-type:none} ol {padding-left:0px;}   #maincontent ol  li::before {content: counter(li); color: ' + this.heading_font_color + '!important; display: inline-block; width: 1em; margin-left: 0em !important;font-size:32px; } #maincontent ol li {counter-increment: li}  .emphasized{color:' + this.heading_font_color + ' !important} #maincontent ul,li,p,strong{font-family:' + this.second_font + '} #maincontent ul.list { width:auto; } #maincontent ul.list li { padding:0 0 0 25px ; background:url("' + this.bullet_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat; list-style-type: none ; } a.external { display: block;color:' + this.heading_font_color + '!important; line-height: 25px;float: left;background: url("' + this.link_back_src + '") 0 8px no-repeat;padding: 0 0 7px 21px !important; } ul.link-list li {width: 100%;overflow: hidden;}  ul.link-list li a { border-bottom: 0 !important;} ul.link-list li { width: 100%;overflow: hidden;} #maincontent ul.check-list { width:auto; } #maincontent ul.check-list li { padding:0 0 0 25px !important; background:url("' + this.check_bac_src + '") 0 3px no-repeat; list-style-type: none ; } #maincontent ul.small-ordered-list .ordered-number { color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important}  #maincontent ul.ordered-list .ordered-number {color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important} #maincontent p {padding:0px 0px 25px} #maincontent span.highlighted {color:' + this.heading_font_color + '} #maincontent div.capture h3  {color:#000 !important} #maincontent a {color:' + this.heading_font_color + '!important; } .main-bottom {border-bottom: 1px dotted ' + this.heading_font_color + '!important;}  .white-bottom {border-bottom: 1px dotted #ffffff !important;} </style>');
            this.sc_onthird_image = this.fullpagedata.background_image;


            if (this.fullpagedata.sc_background_is == "1") {
                this.whiteornot = this.heading_font_color;
                this.backcolor = "#ffffff";
                this.li_font_color = "#333333";
            }
            if (this.fullpagedata.sc_background_is == "0") {
                this.whiteornot = "#ffffff";
                this.backcolor = this.main_color;
                this.li_font_color = "#ffffff";
            }

            if (this.is_service_note == '0') {
                this.showNotes()
                this.getNotes()
            }

            ///assignment and learning goals
            if (this.fullpagedata.assignment_id) {
                this.assignment_name = this.fullpagedata.assignment_name
                this.showassignment = true

                this.allow_upload = this.fullpagedata.allow_upload            //if == 1
                this.assign_type = this.fullpagedata.indi_or_team             //if ==1 individual else team
                this.assignmentdata = this.fullpagedata.assignment_data
                if (this.assignmentdata['0'].learning_goaldata) {
                    this.learninggoals = this.assignmentdata['0'].learning_goaldata
                }
                if (this.assign_type == '2') {
                    if (this.assignmentdata['0'].teamdata) {

                        let teamalldata: any[] = []
                        let storeteamdata: any[] = []
                        teamalldata = this.assignmentdata['0'].teamdata
                        for (let i = 0; i < teamalldata.length; i++) {
                            if (this.user_slug === teamalldata[i].user_slug) {
                                this.teamid = teamalldata[i].as_tid
                            }
                        }
                        for (let i = 0; i < this.teamsvalue.length; i++) {
                            storeteamdata.push(teamalldata.filter(v => v.as_tid === this.teamsvalue[i]))
                        }

                        this.teamdata = storeteamdata.filter(value => Object.keys(value).length !== 0)

                        console.log(this.teamdata)
                        this.assignmentid = this.fullpagedata.assignment_id
                    }
                }

                if (this.showassignment) {
                    this.assignmentShow()
                    this.getResults()
                    this.getUpload()
                }
            }

        }, (error) => {
            console.log(error);
        })


    }

    getResults() {
        this.result.emit({aid: this.assignmentid, pid: this.id, type: this.assign_type, aname: this.assignment_name})
    }

    getUpload() {
        this.upload.emit({
            aid: this.assignmentid,
            pid: this.id,
            type: this.assign_type,
            tid: this.teamid,
            aname: this.assignment_name
        })
    }

    assignmentShow() {
        this.assignment.emit({
            show_assign: this.showassignment,
            allow_uplaod: this.allow_upload,
            access: this.user_access.isuploadassignments
        })
    }

    showNotes() {
        this.notesicon.emit({
            isnoteallowed: this.is_service_note,
            notes_access: this.user_access.isaddnote,
            notification: this.notification
        })
    }

    getNotes() {
        this.notes.emit(this.id)
    }


    getTuotrVideo() {
        this.httpclient.get(this.api + 'auth/view_tutorvideo?token=' + this.tokenvalue + '&page_id=' + this.id).subscribe((data: tutorvideo) => {
            console.log(data)
            if (data.tutorvideo != null) {
                this.alltutordata = data.tutorvideo

                this.video_src = this.domSanitizer.bypassSecurityTrustResourceUrl(data.tutorvideo.video_url)
                this.deep_dive_segment1 = data.tutorvideo.deep_dive_segment1
                this.deep_dive_segment2 = data.tutorvideo.deep_dive_segment2
                this.deep_dive_segment3 = data.tutorvideo.deep_dive_segment3

                if (data.tutorvideo.abstract_segment1) {
                    this.abstract_segment1 = this.domSanitizer.bypassSecurityTrustHtml(data.tutorvideo.abstract_segment1)
                }
                if (data.tutorvideo.abstract_segment2) {
                    this.abstract_segment2 = this.domSanitizer.bypassSecurityTrustHtml(data.tutorvideo.abstract_segment2)
                }
                if (data.tutorvideo.abstract_segment3) {
                    this.abstract_segment3 = this.domSanitizer.bypassSecurityTrustHtml(data.tutorvideo.abstract_segment3)
                }
                if (data.tutorvideo.title_segment1) {
                    this.title_segment1 = data.tutorvideo.title_segment1;
                }
                if (data.tutorvideo.title_segment2) {
                    this.title_segment2 = data.tutorvideo.title_segment2;
                }
                if (data.tutorvideo.title_segment3) {
                    this.title_segment3 = data.tutorvideo.title_segment3;
                }
                if (data.tutorvideo.thumbnail) {
                    this.title1_img = data.tutorvideo.thumbnail
                }
                if (data.tutorvideo.thumbnail2) {
                    this.title2_img = data.tutorvideo.thumbnail2
                }
                if (data.tutorvideo.thumbnail3) {
                    this.title3_img = data.tutorvideo.thumbnail3
                }
                if (data.tutorvideo.start_segment2) {
                    this.start_segment2 = parseInt(data.tutorvideo.start_segment2)
                }
                if (data.tutorvideo.start_segment3) {
                    this.start_segment3 = parseInt(data.tutorvideo.start_segment3)
                }


                var that = this;
                $(document).ready(function () {

                    //tutor video      //old own remove if all works good in ios app
                    // $('#vdh_1').click(function () {
                    //   console.log('one clicked')
                    //   that.seekVideoTime(1);

                    // })
                    // $('#vdh_2').click(function () {
                    //   that.seekVideoTime(2)
                    // })
                    // $('#vdh_3').click(function () {
                    //   that.seekVideoTime(3)

                    // })
                    //end tutor video

                    //vimeo video thumbnail


                    //images thumbnail


                    //common
                    //    $("#videoimagethumbnail li").on("click", "img", function (event) {
                    //     that.vimeo_video_value = $(this).closest('li').data('value');
                    //     let splitcomma=that.vimeo_video_value.split(',')
                    //     let src=splitcomma[0]
                    //     let type=splitcomma[1]
                    //     let index=$(this).parent('li').index()

                    //    that.mainHolder = $('.mediaBlock').find(".main-display")
                    //    $(that.mainHolder).empty()


                    //    that.thumbnailVideoImage(type,index,src)

                    //    $('img').parent().parent().find("li").removeClass("active");
                    //    $('img').parent().addClass("active");

                    //    $('.capture').find("div").hide();
                    //    $('.capture').find('div').removeClass('hide')
                    //    $('.capture').find(".capture" + index).show();
                    //  });


                });


                //for video to get track
                setTimeout(() => {
                    if (this.video_src) {
                        this.iframe = document.querySelector('iframe#tutorplayer');
                        this.player = new Player(this.iframe);

                        this.player.on('play', function () {
                            console.log('played the video!');
                            $('#play').css('display', 'none')
                            $('#stop').css('display', 'block')
                            $('#play2').css('display', 'none')
                            $('#stop2').css('display', 'block')
                            $('#play3').css('display', 'none')
                            $('#stop3').css('display', 'block')
                        });
                        this.player.on('pause', function () {
                            console.log('pause the video!');
                            $('#play').css('display', 'block')
                            $('#stop').css('display', 'none')
                            $('#play2').css('display', 'block')
                            $('#stop2').css('display', 'none')
                            $('#play3').css('display', 'block')
                            $('#stop3').css('display', 'none')
                        });


                        let that = this;
                        this.player.on('timeupdate', function (object) {
                            // console.log('timeupdate the video!',object);
                            that.trackVideo(object)

                        });

                    }

                }, 1000)

                ///show hide vd (summer note abstract_segment )
                setTimeout(() => {
                    if (this.abstract_segment1) {
                        $('#vd_1').css('display', 'block')
                        $('#vd_2').css('display', 'none')
                        $('#vd_3').css('display', 'none')
                        return true;
                    } else if (this.abstract_segment2) {
                        console.log('2', this.abstract_segment2)
                        $('#vd_1').css('display', 'none')
                        $('#vd_2').css('display', 'block')
                        $('#vd_3').css('display', 'none')
                        return true;
                    } else {
                        console.log('3', this.abstract_segment3)
                        $('#vd_1').css('display', 'none')
                        $('#vd_2').css('display', 'none')
                        $('#vd_3').css('display', 'block')
                        return true;
                    }
                }, 100)

            }
        }), (error) => {

            console.log(error)
        }


    }

    videoPalyPause(v) {
        console.log(v)
        if (v == 'play') {
            this.player.play().then(function () {
                // the video was played
            }).catch(function (error) {
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
        }
        if (v == 'stop') {
            this.player.pause().then(function () {
                // the video was paused
            }).catch(function (error) {
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            })
        }

        this.player.on('play', function () {
            console.log('played the video!');
            $('#play').css('display', 'none')
            $('#stop').css('display', 'block')
        });
        this.player.on('pause', function () {
            console.log('pause the video!');
            $('#play').css('display', 'block')
            $('#stop').css('display', 'none')
        });

    }


    //changevideo play time
    seekVideoTime(number) {
        console.log(number)
        let time = 0
        if (number == 1) {
            time = 0;

            $('#vd_1').css('display', 'block')
            $('#vd_2').css('display', 'none')
            $('#vd_3').css('display', 'none')

            //video contnet
            $('#vc_1').children("a").addClass('active')
            $('#vc_2').children("a").removeClass('active')
            $('#vc_3').children("a").removeClass('active')
        }
        if (number == 2) {
            time = this.start_segment2

            $('#vd_1').css('display', 'none')
            $('#vd_2').css('display', 'block')
            $('#vd_3').css('display', 'none')

            //video contnet
            $('#vc_1').children("a").removeClass('active')
            $('#vc_2').children("a").addClass('active')
            $('#vc_3').children("a").removeClass('active')

        }
        if (number == 3) {
            time = this.start_segment3

            $('#vd_1').css('display', 'none')
            $('#vd_2').css('display', 'none')
            $('#vd_3').css('display', 'block')

            //video contnet
            $('#vc_1').children("a").removeClass('active')
            $('#vc_2').children("a").removeClass('active')
            $('#vc_3').children("a").addClass('active')
        }
        var that = this
        this.player.setCurrentTime(time).then(function (seconds) {
            // seconds = the actual time that the player seeked to
            that.player.play().then(function () {
                // the video was played
            }).catch(function (error) {
                switch (error.name) {
                    case 'PasswordError':
                        // the video is password-protected and the viewer needs to enter the
                        // password first
                        break;

                    case 'PrivacyError':
                        // the video is private
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
        }).catch(function (error) {
            switch (error.name) {
                case 'RangeError':
                    // the time was less than 0 or greater than the video’s duration
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });
    }


    trackVideo(object) {
        // console.log(object)
        let third: any;
        var that = this;

        if (that.start_segment2) {

            if (object.seconds < that.start_segment2) {

                $('#vd_1').css('display', 'block')
                $('#vd_2').css('display', 'none')
                $('#vd_3').css('display', 'none')

                //video contnet
                $('#vc_1').children("a").addClass('active')
                $('#vc_2').children("a").removeClass('active')
                $('#vc_3').children("a").removeClass('active')
                return true;
            }

            if (that.start_segment3) {

                third = (object.seconds < that.start_segment3);
            } else {

                third = true;
            }
            if ((object.seconds > that.start_segment2) && (third)) {

                //video contnet
                $('#vc_1').children("a").removeClass('active')
                $('#vc_2').children("a").addClass('active')
                $('#vc_3').children("a").removeClass('active')
                return true;
            }
        }
        if (that.start_segment3) {
            if (object.seconds < that.start_segment3) {


                //video contnet
                $('#vc_1').children("a").addClass('active')
                $('#vc_2').children("a").removeClass('active')
                $('#vc_3').children("a").removeClass('active')
                return true;
            } else {

                //video contnet
                $('#vc_1').children("a").removeClass('active')
                $('#vc_2').children("a").removeClass('active')
                $('#vc_3').children("a").addClass('active')
                return true;
            }
        }

    }


    deepDiveId(id) {
        console.log(id)
        if (id == 'vdh_1') {
            $('#vdh_1').children("a").removeClass('play-tutor-video')
            $('#vdh_1').children("a").addClass('play-tutor-video-animated')
            $('#vdh_2').children("a").removeClass('play-tutor-video-animated')
            $('#vdh_3').children("a").removeClass('play-tutor-video-animated')
            setTimeout(() => {
                $('#vdh_1').children("a").removeClass('play-tutor-video-animated')
                $('#vdh_1').children("a").addClass('play-tutor-video')
                $('#vdh_2').children("a").removeClass('play-tutor-video-animated')
                $('#vdh_3').children("a").removeClass('play-tutor-video-animated')
            }, 4000)
        }
        if (id == 'vdh_2') {
            $('#vdh_2').children("a").removeClass('play-tutor-video')
            $('#vdh_2').children("a").addClass('play-tutor-video-animated')
            $('#vdh_1').children("a").removeClass('play-tutor-video-animated')
            $('#vdh_3').children("a").removeClass('play-tutor-video-animated')
            setTimeout(() => {
                $('#vdh_2').children("a").removeClass('play-tutor-video-animated')
                $('#vdh_2').children("a").addClass('play-tutor-video')
                $('#vdh_1').children("a").removeClass('play-tutor-video-animated')
                $('#vdh_3').children("a").removeClass('play-tutor-video-animated')
            }, 4000)
        }
        if (id == 'vdh_3') {
            $('#vdh_3').children("a").removeClass('play-tutor-video')
            $('#vdh_3').children("a").addClass('play-tutor-video-animated')
            $('#vdh_1').children("a").removeClass('play-tutor-video-animated')
            $('#vdh_2').children("a").removeClass('play-tutor-video-animated')
            setTimeout(() => {
                $('#vdh_3').children("a").removeClass('play-tutor-video-animated')
                $('#vdh_3').children("a").addClass('play-tutor-video')
                $('#vdh_1').children("a").removeClass('play-tutor-video-animated')
                $('#vdh_2').children("a").removeClass('play-tutor-video-animated')
            }, 4000)
        }

    }

    thumbnailVideoImage(type, index, v, check, id, enlarge_img) {
        console.log(type, index, v, check, id, enlarge_img)
        // $('.main-display ').empty()
        if (check == 'both') {
            $('#' + id).empty();
            if (type == "img") {
                $('.both').append("<a id=\"enlargeimg\"  class=\"enlarge\" data-backdrop=\"static\" data-keyboard=\"false\" data-target=\"#enlargeimgmodal\" data-toggle=\"modal\" onclick=\"Window.myComponent.getEnlargeImage('" + enlarge_img + "')\">enlarge</a>");
                // $('.both').append("<img   src=\"" + v + "\" alt=\"\" height=\"362\" width=\"648\" />");
                $('.both').append("<img   src=\"" + v + "\" alt=\"\"/>");
            }

            if (type == "external-video") {


                $('#enlargeimg').remove();

                $('.both').append("<iframe   width=\"648\" height=\"362\" src=\"" + v + "\" frameborder=\"0\" allowfullscreen></iframe>");
            }

            $('img').parent().parent().find("li").removeClass("active");
            $('img').parent().addClass("active");

            $('.capture').find("div").hide();
            $('.capture').find('div').removeClass('hide')
            $('.capture').find(".capture" + index).show();
        }
        if (check == 'singlevideo') {

            $('.singlevideo').empty();
            $('#' + id).remove();
            $('.singlevideo').append("<iframe id=\"" + id + "\"  width=\"648\" height=\"362\" src=\"" + v + "\" frameborder=\"0\" allowfullscreen></iframe>");
            $('img').parent().parent().find("li").removeClass("active");
            $('img').parent().addClass("active");

            $('.capture').find("div").hide();
            $('.capture').find('div').removeClass('hide')
            $('.capture').find(".capture" + index).show();
        }
        if (check == 'singleimage') {
            $('.singleimage').empty();
            $('#' + id).remove();
            // $('.singleimage').append("<img id=\"" + id + "\"  src=\"" + v + "\" alt=\"\" height=\"362\" width=\"648\" />" removed height and width for selectable media snippet.);
            $('.singleimage').append("<img id=\"" + id + "\"  src=\"" + v + "\" alt=\"\" />");
            $('img').parent().parent().find("li").removeClass("active");
            $('img').parent().addClass("active");

            $('.capture').find("div").hide();
            $('.capture').find('div').removeClass('hide')
            $('.capture').find(".capture" + index).show();
        }


    }


    getEnlargeImage(v) {
        this.shareservice.enLargeImagePath(v)
    }


    // ngAfterViewInit()
    // {

    // }

    // ngOnDestroy()
    // {

    // }


}

export interface onethirdpagedata {
    differentpage: any[];
    page: any[];
    notification: any;
}

export interface tutorvideo {
    tutorvideo: any;
}